<template>
    <div class="Notifications">
        <q-card
            class="NotificationsCard"
            bordered
        >
            <q-card-section class="NotificationsBody">
                <div class="Container">
                    <NotificationList
                        ref="table"
                        :rows="notifications"
                        :total="total"
                        :loading="isFetching"
                        @on-fetch-data="fetchData"
                        @on-visualization="handleVisualization"
                        @on-change-visibility="fetchFilteredData"
                        @on-filter-date="fetchFilteredData"
                        @on-click-content="handleClickContent"
                    />
                    <QDialog
                        v-model="notificationInfo"
                        @hide="handleCloseModal"
                    >
                        <QCard class="flex column Card">
                            <QBar class="bg-primary text-white">
                                <div class="text-subtitle1 text-weight-medium">
                                    {{ $t('general.content') }}
                                </div>
                                <QSpace />
                                <QBtn
                                    v-close-popup
                                    dense
                                    flat
                                    color="white"
                                    icon="close"
                                    @click="handleCloseModal"
                                />
                            </QBar>
                            <q-card-section class="Body q-pa-lg">
                                <div class="text-body2">
                                    {{ notificationInfo.content }}
                                </div>
                            </q-card-section>
                        </QCard>
                    </QDialog>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import {
    Api, apiRequest, notifyError, notifySuccess,
} from '@/api'
import { NotificationList } from './sections'

export default {
    name: 'NotificationsComponent',
    components: {
        NotificationList,
    },
    props: {
        headers: VueTypes.shape({
            search: VueTypes.string.def(''),
            archived: VueTypes.bool.def(false),
        }),
    },
    data() {
        return {
            notifications: undefined,
            total: undefined,
            isFetching: false,
            notificationInfo: undefined,
        }
    },
    computed: {
        params() {
            const pagination = this.$refs.table.getPagination()
            return {
                ...pagination,
                ...this.headers,
                alreadySeen: this.$refs.table.activateVisibility,
            }
        },
    },
    watch: {
        headers(value) {
            if (value) this.fetchData(this.params)
        },
    },
    beforeMount() {
        const { organizationId } = this.$route.params || {}
        this.organizationId = organizationId
    },
    mounted() {
        this.fetchData(this.params)
    },
    methods: {
        handleUpdateItem({ uuid, name, description }) {
            this.$refs.editPrDialog.open({ uuid, name, description })
        },
        handleNewItem() {
            this.$refs.newPrDialog.open()
        },
        normalizeNotifications(notifications) {
            return notifications.map(({ organization = '', ...rest }) => ({
                ...rest,
                organization: organization.name,
            }))
        },
        async handleVisualization({ uuid }) {
            this.isFetching = true
            apiRequest(Api().notifications.create({ notificationUid: uuid }))
                .then(() => {
                    notifySuccess(this.$t('notifications.notifications.seen.text'))
                    this.fetchData(this.params)
                })
                .catch(notifyError)
                .finally(() => { this.isFetching = false })
        },
        fetchFilteredData(parameters) {
            const params = { ...this.params, ...parameters }
            this.fetchData(params)
        },
        async fetchData(parameters) {
            this.isFetching = true
            const params = this.normalizeParams(parameters)
            apiRequest(Api().notifications.list(params))
                .then(({ data, total }) => {
                    this.notifications = this.normalizeNotifications(data)
                    this.total = total
                })
                .catch(notifyError)
                .finally(() => { this.isFetching = false })
        },
        normalizeParams(parameters) {
            const {
                search, page, rowsPerPage, endDate, startDate, alreadySeen,
            } = parameters
            return {
                organizationUid: this.organizationId,
                ...(this.getStartParam(page, rowsPerPage)),
                ...(rowsPerPage ? { limit: rowsPerPage } : {}),
                ...(endDate ? { endDate } : {}),
                ...(startDate ? { startDate } : {}),
                alreadySeen,
                search: search || null,
            }
        },
        getStartParam(page, rowsPerPage) {
            return rowsPerPage ? { start: (page - 1) * rowsPerPage } : {}
        },
        handleCloseModal() {
            this.notificationInfo = undefined
        },
        handleClickContent(row) {
            this.notificationInfo = row
        },
    },
}
</script>
<style scoped lang="scss">
.NotificationsCard {
    background: $white;
}

.NotificationsHeader {
    padding: 0 16px;
}

.NotificationsTitle {
    font-weight: 500;
}

.NotificationsBody {
    padding: 16px;
}

.Card {
    &:deep(.Body) {
        margin: 30px 0;
    }
}
.Card .Body {
    max-width: 700px !important;
    min-width: 500px
}
</style>
